//This page displays all the workers belonging to a user 
import {useState, useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {getWorkers } from  '../features/workers/workerSlice'

import Spinner from '../components/Spinner'
import WorkerItem from '../components/WorkerItem'
import {FaUserPlus} from 'react-icons/fa'
import { reset, resetWorkersMessage } from '../features/workers/workerSlice'; 
import { reset as resetSelectedWorker} from '../features/selectedWorker/selectedWorkerSlice'
import { useSubStatus } from '../hooks/useSubStatus';
import { toast } from 'react-toastify';
function Workers() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { workers, isLoading, message } = useSelector((state) => state.workers);
    const { subStatus } = useSubStatus(); // Get subscription status

    const [searchTerm, setSearchTerm] = useState("");

    const filterWorkers = (searchTerm) => {
        return Array.isArray(workers)
            ? workers.filter(
                  (worker) =>
                      worker.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                      worker.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                      worker.phone.includes(searchTerm)
              )
            : [];
    };

    
    useEffect(() => {
        dispatch(getWorkers());
        dispatch(resetSelectedWorker());
    }, [dispatch]);

    useEffect(() => {
        if (message) {
            toast(message);
            dispatch(resetWorkersMessage())
        }
    }, [message, dispatch]);

    if (isLoading) {
        return <Spinner />;
    }

    const canAccessNewWorker = subStatus === 'trialing' || subStatus === 'active';

    return (
        <>
            <div className="mt-2 mx-auto px-4">
                <div className="flex items-center justify-between">
                    <div className="flex-1 flex justify-center">
                        <input
                            type="text"
                            placeholder="Search by name or phone"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="w-full max-w-md px-4 py-2 rounded-lg bg-sage text-charcoal placeholder-gray-600 shadow-md focus:outline-none focus:ring-2 focus:ring-teal transition duration-300 ease-in-out transform hover:scale-105"
                        />
                    </div>
                    <div className="ml-4">
                        <button
                            onClick={() => {
                                if (canAccessNewWorker) {
                                    dispatch(reset());
                                    navigate('/new-worker');
                                }
                            }}
                            disabled={!canAccessNewWorker} // Disable button if subscription is invalid
                            className={`font-mono font-semibold inline-flex items-center px-4 py-2 rounded-md shadow-md transition ${
                                canAccessNewWorker
                                    ? 'bg-orangem text-white hover:bg-orange-400'
                                    : 'bg-gray-400 text-gray-700 cursor-not-allowed'
                            }`}
                        >
                            <FaUserPlus className="mr-2 font-semibold text-orange-950 text-xl" />
                            <span className="hidden sm:inline">New Worker</span>
                        </button>
                    </div>
                </div>
            </div>

            <div>
                <div className="container grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                    {filterWorkers(searchTerm).map((worker) => (
                        <WorkerItem key={worker.id} worker={worker} />
                    ))}
                </div>
            </div>
        </>
    );
}

export default Workers;